import PortalLearningPath from '@classes/LearningPath'
import FlexProgress from '@layouts/LearningPath/ProgramContent/FlexProgress'
import NonFlexProgress from '@layouts/LearningPath/ProgramContent/NonFlexProgress'
import React from 'react'
import FlexModuleProgress from '@layouts/LearningPath/ProgramContent/FlexModuleProgress'
import { StoreProps } from '@interfaces/StoreState'
import { useSelector } from 'react-redux'

export interface ProgramContentProp {
  Path: PortalLearningPath
  Elective?: PortalLearningPath
}

const ProgramContent: React.FC<ProgramContentProp> = ({ Path, Elective }) => {
  const { userPermissions } = useSelector(({ permissions }: StoreProps) => ({
    userPermissions: permissions.permissions,
  }))
  const LPModuleFlag = userPermissions['flag::LP-modules']?.show

  if (Path.IsCTMaterial) {
    return null
  }

  return Path.IsFlex ? (
    Path.Modules?.length && LPModuleFlag ? (
      <FlexModuleProgress Path={Path} Elective={Elective} />
    ) : (
      <FlexProgress Path={Path} Elective={Elective} />
    )
  ) : (
    <NonFlexProgress Path={Path} />
  )
}
export default ProgramContent
